document.addEventListener('alpine:init', function () {
  Alpine.data('switchTab', function (needControl = true, syncEl = '') {
    return {
      current: 1,
      container: null,
      line: null,
      init() {
        this.container = this.$el.querySelector('.switch-tab');
        this.line = this.container.querySelector('.switch-line');
        this.onChange();
        if (syncEl) ltLazyLoad(this.syncFlickity.bind(this))
      },
      onClick(idx) {
        const beforeIdx = this.current;
        this.current = idx + 1;
        this.onChange();
        needControl && this.onControl(beforeIdx);
      },
      syncFlickity() {
        const flkty = $(syncEl).data('flickityt4s')
        if (!flkty) return
        flkty.on('change', (idx) => {
          this.current = idx + 1
          this.onChange()
        });
        this.$watch("current", function (val) {
          flkty.select(val - 1)
        })
      },
      _transitionContent(froms, tos) {
        const animates = froms.map((el) => {
          el.animate(
            { opacity: [1, 0] },
            {
              duration: 400,
              easing: 'ease',
            }
          ).finished;
        });
        Promise.all(animates).then(() => {
          froms.forEach((el) => (el.style.display = 'none'));
          tos.forEach((el) => (el.style.display = 'revert'));
          tos.forEach((el) => {
            el.animate(
              { opacity: [0, 1] },
              {
                duration: 400,
                easing: 'ease',
              }
            );
          });
        });
      },
      onControl(beforeIdx) {
        const currentNavEl = this.container.querySelector(`.switch-item:nth-child(${this.current})`);
        const currentNavId = currentNavEl.getAttribute('data-id');
        const beforeNavEl = this.container.querySelector(`.switch-item:nth-child(${beforeIdx})`);
        const beforeNavId = beforeNavEl.getAttribute('data-id');
        const beforeControlEls = beforeNavId.split(',').map((id) => document.querySelector(id));
        const currentControlEls = currentNavId.split(',').map((id) => document.querySelector(id));
        this._transitionContent(beforeControlEls, currentControlEls);
      },
      onChange() {
        const nav = this.container.querySelector(`.switch-item:nth-child(${this.current})`);
        const { offsetLeft, offsetWidth } = nav;
        const containerOffsetWidth = this.container.offsetWidth;
        const clipLeft = offsetLeft;
        const clipRight = offsetLeft + offsetWidth;
        const start = Number(100 - (clipRight / containerOffsetWidth) * 100).toFixed(2);
        const end = Number((clipLeft / containerOffsetWidth) * 100).toFixed(2);
        this.line.style.clipPath = `inset(0 ${start}% 0 ${end}% round var(--rd))`;
      },
    };
  });
});

